<div class="buyButton" [ngClass]="{ remove: count >= 1 }">
  <!-- default -->
  <button
    *ngIf="count === 0 || (count >= 1 && separateRemoveLink)"
    [id]="buttonId"
    type="button"
    #menuButton
    class="action-button"
    [class.active]="count !== 0 && !canOnlyRemove"
    (keydown)="handleBuyButtonKeyEvent($event)"
    (click)="handleButtonClick()"
  >
    {{ label }}
  </button>
  <button
    *ngIf="count >= 1"
    [id]="removeButtonId"
    type="button"
    #menuButton
    [attr.aria-controls]="removeButtonId"
    class="remove-button"
    (keydown)="handleRemoveButtonKeyEvent($event)"
    (click)="handleRemoveButtonClick()"
  >
    {{ removeLabel }}
  </button>
</div>
